import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import heartIcon_inactive from 'styles/staticAssets/images/heartIcon_inactive.svg';
import heartIcon_active from 'styles/staticAssets/images/heartIcon_active_white.svg';
import heartIcon_activeFavourite from 'styles/staticAssets/images/heartIcon_activeFavourite.svg';
import heartIcon_inactiveFavourite from 'styles/staticAssets/images/heartIcon_inactiveFavourite.svg';
import { MENU_PLP_CONSTANT } from '../MenuPLPConstants/MenuPLPConstants';
import {
  getItemQuantity,
  isEmptyObject,
  getTernaryValue,
  getValueOrDefaultObject,
  getValueOrnull,
  getValueOrDefaultZero,
  getAndCheck,
} from 'common/utilities/utils';
import MENU_CONSTANT from 'organisms/GenericMenuCategories/MenuConstants/MenuConstants';
import { CART_PAGE_CONSTANTS } from 'organisms/CartPage/Constants/CartPageConstants';
import FoodItemListHandlers from 'organisms/CartPage/Presentation/ReusableComponents/FoodItemListHandlers';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { showCustomizationModalAction } from '@kfc-global/react-shared/redux/Actions/CartAction';
import PlpMenuCardViewComponent from 'atoms/PlpMenuCard/Presentation/PlpMenuCardViewComponent';
import { modgrpsDetails } from 'organisms/MenusPLP/MenusPlpUtilities/MenusPlpUtils';
const { CARD_TYPE } = MENU_PLP_CONSTANT;

const getCardTypeNameForSmall = (allowClickOnProductCard, discount, specials, exclusive, timer) => {
  if (allowClickOnProductCard && (discount || specials || exclusive || timer)) {
    return 'small-menu-product-card small-menu-product-card-long product-card-active';
  } else if (allowClickOnProductCard && !(discount || specials || exclusive || timer)) {
    return 'small-menu-product-card product-card-active';
  } else if (!allowClickOnProductCard && (discount || specials || exclusive || timer)) {
    return 'small-menu-product-card small-menu-product-card-long';
  } else {
    return 'small-menu-product-card';
  }
};

const getCardTypeName = (cardType, allowClickOnProductCard, discount, specials, exclusive, timer) => {
  if (cardType === CARD_TYPE.LARGE) {
    return allowClickOnProductCard ? 'menu-product-card product-card-active' : 'menu-product-card';
  } else if (cardType === CARD_TYPE.MEDIUM) {
    return allowClickOnProductCard ? 'medium-menu-product-card product-card-active' : 'medium-menu-product-card';
  } else if (cardType === CARD_TYPE.SMALL) {
    return getCardTypeNameForSmall(allowClickOnProductCard, discount, specials, exclusive, timer);
  } else if (cardType === CARD_TYPE.CAROUSAL) {
    return 'carousal-menu-product-card';
  }
};

const getProductImageClassName = cardType => {
  if (cardType === CARD_TYPE.LARGE) {
    return 'menu-product-image';
  } else if (cardType === CARD_TYPE.MEDIUM) {
    return 'medium-menu-product-image';
  } else if (cardType === CARD_TYPE.SMALL) {
    return 'small-menu-product-image';
  } else if (cardType === CARD_TYPE.CAROUSAL) {
    return 'carousal-menu-product-image';
  }
};

const getMenuProductHeader = (
  cardType,
  discount,
  specials,
  exclusive,
  { timer, newitem, topseller, customlabelfield },
) => {
  if (cardType === CARD_TYPE.LARGE) {
    return 'menu-product-header';
  } else if (cardType === CARD_TYPE.MEDIUM) {
    return 'medium-menu-product-header';
  } else if (cardType === CARD_TYPE.SMALL) {
    return discount || specials || exclusive || timer || newitem || topseller || customlabelfield
      ? 'small-menu-product-header-shift'
      : 'small-menu-product-header';
  } else if (cardType === CARD_TYPE.CAROUSAL) {
    return 'carousal-menu-product-header';
  }
};

const getVegNonvegClassName = cardType => {
  if (cardType === CARD_TYPE.LARGE) {
    return 'menu-vegOrNonVeg';
  } else if (cardType === CARD_TYPE.MEDIUM) {
    return 'medium-menu-vegOrNonVeg';
  } else if (cardType === CARD_TYPE.SMALL) {
    return 'small-menu-vegOrNonVeg';
  } else if (cardType === CARD_TYPE.CAROUSAL) {
    return 'carousal-menu-vegOrNonVeg';
  }
};

const menuProductPriceClassName = cardType => {
  if (cardType === CARD_TYPE.LARGE) {
    return 'menu-product-price';
  } else if (cardType === CARD_TYPE.MEDIUM) {
    return 'medium-menu-product-price';
  } else if (cardType === CARD_TYPE.SMALL) {
    return 'small-menu-product-price';
  } else if (cardType === CARD_TYPE.CAROUSAL) {
    return 'carousal-menu-product-price';
  } else {
    return '';
  }
};

const getPriceClassName = (baseprice, cardFor) => {
  return baseprice && cardFor !== 'recommended' ? 'availableprice-withbaseprice' : '';
};

const menuProductDescriptionClassName = cardType => {
  if (cardType === CARD_TYPE.LARGE) {
    return 'menu-product-description';
  } else if (cardType === CARD_TYPE.MEDIUM) {
    return 'medium-menu-product-description';
  } else if (cardType === CARD_TYPE.SMALL) {
    return 'small-menu-product-description';
  } else if (cardType === CARD_TYPE.CAROUSAL) {
    return 'carousal-menu-product-description';
  } else {
    return '';
  }
};

export const classesBy = (CARDTYPE, CHECK) => {
  let classes;
  let btnType = 'button activeBtn';
  btnType += CHECK ? ' blackButton' : ' redButton';
  switch (CARDTYPE) {
    case CARD_TYPE.LARGE:
      classes = 'menu-cart-button';
      break;
    case CARD_TYPE.MEDIUM:
      classes = 'medium-menu-cart-button';
      break;
    case CARD_TYPE.SMALL:
      classes = 'small-menu-cart-button';
      break;
    case CARD_TYPE.CAROUSAL:
      classes = 'carousal-menu-cart-button';
      break;
    default:
      classes = '';
      break;
  }
  return `${btnType} ${classes}`;
};

export const classesCardButton = (itemCount, loggedIn) => {
  if (itemCount) {
    return 'cardButton ' + loggedIn;
  } else {
    return `cardButtonOnly cardButtonOnly-in ` + loggedIn;
  }
};

const menuCardBtnText = data => {
  const { ADD_TO_CART } = MENU_CONSTANT;
  let btnText = translateWithI18Next(ADD_TO_CART);
  let className = '';
  let enabled = true;

  if (data?.isStoreNone) {
    btnText = 'Store Closed';
    className = 'no-store-selected';
    enabled = false;
  } else if (data?.isStoreClosed) {
    btnText = 'Store Closed';
    className = 'store-closed';
    enabled = false;
  }

  return {
    btnText,
    className,
    enabled,
  };
};

const classEnableAddToCart = (enableAddToCartButton, cardType, checkLoading, storeClosedData) => {
  if (enableAddToCartButton) {
    return `${classesBy(cardType, checkLoading)} ${menuCardBtnText(storeClosedData).className}`;
  } else {
    return 'button btn-black medium-menu-cart-button';
  }
};

const getSpecificRibbonBanner = (specials, discount, exclusive, newitem, topseller, customlabelfield) => {
  let redRibbonCard;
  if (customlabelfield) {
    redRibbonCard = <span data-testid='exclusive-id'>{customlabelfield}</span>;
  } else if (specials) {
    redRibbonCard = specials;
  } else if (discount) {
    redRibbonCard = discount;
  } else if (exclusive) {
    redRibbonCard = (
      <span data-testid='exclusive-id'>{translateWithI18Next(MENU_PLP_CONSTANT.MENU_CARD.EXCLUSIVE_DEAL)}</span>
    );
  } else if (newitem) {
    redRibbonCard = <span data-testid='new-id'>{translateWithI18Next(MENU_PLP_CONSTANT.MENU_CARD.NEW)}</span>;
  } else {
    redRibbonCard = getTernaryValue(
      topseller,
      <span data-testid='topseller-id'>{translateWithI18Next(MENU_PLP_CONSTANT.MENU_CARD.TOP_SELLER)}</span>,
      null,
    );
  }
  return redRibbonCard;
};
const classFavouriteIconActive = cardType => {
  return cardType === CARD_TYPE.CAROUSAL ? heartIcon_active : heartIcon_activeFavourite;
};

const classFavouriteIconInActive = cardType => {
  return cardType === CARD_TYPE.CAROUSAL ? heartIcon_inactive : heartIcon_inactiveFavourite;
};

const checkForBasePriceInMenu = (baseprice, cardFor) => {
  return Boolean(baseprice) && cardFor !== 'recommended';
};

const displayPrice = (baseprice, currencyConversionFactor) => {
  let price;
  price = (
    <>
      <span className='price-display'>old price</span>
      <span className='base-price-menu'>
        {MENU_PLP_CONSTANT.MENU_CARD.CURRENCY}
        {(parseFloat(baseprice) / currencyConversionFactor).toFixed(2)}
      </span>
    </>
  );
  return price;
};

const MenuCard = props => {
  const {
    cardId,
    cardType,
    discount,
    specials,
    exclusive,
    timer,
    availability = [],
    tenantData,
    customizable,
    categoryId,
    activeId,
    addFavourite,
    removeFavourite,
    item,
    isHidden,
    cardFor,
    setShowTopScrollBtn,
    userParams,
  } = props;

  const { QUANTITY_ACTION } = CART_PAGE_CONSTANTS;
  const dispatch = useDispatch();
  const tenantId = tenantData?.tenantId;
  const { componentOptions = {} } = tenantData;
  const { PlpProductCard = {} } = componentOptions;
  const { allowClickOnProductCard = false } = PlpProductCard;
  const cartReducer = useSelector(data => data.cartReducer);
  const customerinfo = useSelector(data => data.profileReducer?.basic);
  const { cartData = {}, isAddItemLoading = false } = getValueOrDefaultObject(cartReducer);
  const [itemCount, setItemCount] = useState(0);
  const [itemFoodlineId, setItemFoodlineId] = useState(null);
  const [itemEntries, setItemEntries] = useState(0);
  const customerId = customerinfo?.id;
  const favouriteItems = useSelector(data => getValueOrnull(data.profileReducer?.favouriteItems));
  const [enableAddToCartButton, setEnableAddToCardButton] = useState(true);
  const [cardCat, setCardCat] = useState('product');
  const { flatResponse: { productMapById = {} } = {} } = useSelector(({ menuReducer }) => menuReducer) ?? {};
  const [getCardName, setCardName] = useState('');
  const [itemUnitPrice, setItemUnitPrice] = useState(0);
  const [filteredPreviousData, setFilteredPreviousData] = useState([]);
  const [openCostomizedModal, setOpenCostomizedModal] = useState(false);
  const [FoodId, setFoodId] = useState('');

  const { couponCode = '', amount = 0 } = cartData?.discountLines?.[0] || {};
  const { foodLines, total } = cartData;
  const totalAmount = Number((total / tenantData?.currencyConversionFactor).toFixed(2));
  const discountAmounts = [
    {
      couponCode,
      amount: Number((amount / tenantData?.currencyConversionFactor).toFixed(2)),
    },
  ];

  useEffect(() => {
    if (cardFor) {
      setCardCat(cardFor);
    }
  }, [cardFor]);

  useEffect(() => {
    const getItem = isEmptyObject(cartData) ? getItemQuantity(cardId, cartData) : {};
    const getItemCount = getTernaryValue(isEmptyObject(getItem), getItem.count, 0);
    const getItemfoodLineId = getTernaryValue(isEmptyObject(getItem), getItem.matchedItemFoodLineId, '');
    const getItemEntries = getTernaryValue(isEmptyObject(getItem), getItem.entriesCount, 0);
    const getItemUnitPrice = getTernaryValue(isEmptyObject(getItem), getItem.itemUnitPrice, '');
    setItemCount(getItemCount);
    setItemFoodlineId(getItemfoodLineId);
    setItemEntries(getItemEntries);
    setItemUnitPrice(getItemUnitPrice);
  }, [cartData, cardId]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const setCardTypeName = useCallback(() => {
    setCardName(getCardTypeName(cardType, allowClickOnProductCard, discount, specials, exclusive, timer));
  });

  useEffect(() => {
    setCardTypeName();
  }, [setCardTypeName]);

  const addItemToFavourite = async (tntId, itemDetails, itemAvailability, custInfo) => {
    const price = getValueOrDefaultZero(itemAvailability[0]?.price);
    const payload = {
      mdmId: itemDetails.mdmId,
      id: itemDetails.id,
      name: itemDetails.name,
      imageName: itemDetails.imageName,
      description: itemDetails.longDescription,
      quantity: 1,
      isCustomized: itemDetails.customizable,
      price: price / tenantData?.currencyConversionFactor,
      additionalProperties: itemDetails.additionalProperties,
    };
    await addFavourite(tntId, payload, custInfo);
    await dispatch(
      showCustomizationModalAction({
        showProductListingModal: false,
        categorySelected: categoryId,
      }),
    );
  };

  const unFavouriteAnItem = (tntId, custId, itm) => {
    removeFavourite(tntId, custId, itm.id);
  };

  useEffect(() => {
    setEnableAddToCardButton(true);
  }, [itemCount]);

  const dataFilter = foodItemId => {
    if (cartData?.id) {
      let filteredPreviousDatas = cartData?.foodLines.filter(val => val?.item?.id === foodItemId);
      setFilteredPreviousData(filteredPreviousDatas);
    }
    setFoodId(foodItemId);
    setOpenCostomizedModal(true);
  };

  const updateItemQuantity = (e, flag) => {
    if (userParams.localized) {
      const itemPrice = Number((itemUnitPrice / tenantData?.currencyConversionFactor).toFixed(2));

      let menuItemData = {
        foodName: item?.name,
        foodItemId: item?.mdmId,
        cartPrice: itemPrice,
        modifiers: modgrpsDetails(item),
        customizable: item?.customizable,
        quantity: itemCount,
        foodLineId: itemFoodlineId,
      };
      const { itemQuantityHandler } = FoodItemListHandlers(
        { cartId: cartData?.id, discountAmounts, foodLines, totalAmount },
        tenantData?.tenantId,
        undefined,
        productMapById,
        undefined,
        dispatch,
        undefined,
      );
      if (flag === QUANTITY_ACTION.Increase) {
        if (customizable && itemCount >= 1) {
          dataFilter(menuItemData?.foodItemId);
        } else {
          !customizable && setEnableAddToCardButton(false);
          itemQuantityHandler(menuItemData, QUANTITY_ACTION.Increase);
        }
      } else {
        if (itemEntries > 1) {
          dataFilter(menuItemData?.foodItemId);
        } else {
          setEnableAddToCardButton(false);
          itemQuantityHandler(menuItemData, QUANTITY_ACTION.Decrease);
        }
      }
    }
  };

  const checkLoading = getAndCheck(isAddItemLoading, activeId === cardId);

  const favouriteButtonClickHandler = () => {
    getAndCheck(
      Array.isArray(favouriteItems),
      favouriteItems?.find(el => el?.id === item?.id),
    )
      ? unFavouriteAnItem(tenantId, customerId, item)
      : addItemToFavourite(tenantId, item, availability, customerId);
  };

  return (
    !isHidden && (
      <PlpMenuCardViewComponent
        {...props}
        getCardTypeName={getCardTypeName}
        data-testid='MenuPlpTestId'
        allowClickOnProductCard={allowClickOnProductCard}
        getProductImageClassName={getProductImageClassName}
        getSpecificRibbonBanner={getSpecificRibbonBanner}
        favouriteItems={favouriteItems}
        classFavouriteIconActive={classFavouriteIconActive}
        getCardName={getCardName}
        favouriteButtonClickHandler={favouriteButtonClickHandler}
        itemCount={itemCount}
        classFavouriteIconInActive={classFavouriteIconInActive}
        getMenuProductHeader={getMenuProductHeader}
        getVegNonvegClassName={getVegNonvegClassName}
        menuProductPriceClassName={menuProductPriceClassName}
        checkForBasePriceInMenu={checkForBasePriceInMenu}
        cardCat={cardCat}
        displayPrice={displayPrice}
        getPriceClassName={getPriceClassName}
        menuProductDescriptionClassName={menuProductDescriptionClassName}
        updateItemQuantity={updateItemQuantity}
        classesCardButton={classesCardButton}
        classEnableAddToCart={classEnableAddToCart}
        enableAddToCartButton={enableAddToCartButton}
        checkLoading={checkLoading}
        menuCardBtnText={menuCardBtnText}
        itemFoodlineId={itemFoodlineId}
        openCostomizedModal={openCostomizedModal}
        filteredPreviousData={filteredPreviousData}
        setOpenCostomizedModal={setOpenCostomizedModal}
        cartData={cartData}
        CARD_TYPE={CARD_TYPE}
        setShowTopScrollBtn={setShowTopScrollBtn}
        FoodId={FoodId}
      />
    )
  );
};

export default MenuCard;
